<template>
    <div>
        <div class="row mb-2">
            <span class="col-12 font-weight-bold font-small-5">Biaya atau Beban</span>
            <div class="col-12 mt-50">
                <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                    <b-form-radio v-model="formDatas.biaya_beban" value="biaya-perolehan" disabled>
                        Biaya Perolehan
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.biaya_beban" value="biaya-setelah-perolehan" disabled>
                        Biaya Setelah Perolehan
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.biaya_beban" value="beban" disabled>
                        Beban
                    </b-form-radio>
                </div>
            </div>
        </div>
        <div class="row mb-2" v-if="['biaya-perolehan', 'biaya-setelah-perolehan'].includes(formDatas.biaya_beban)">
            <span class="col-12 font-weight-bold font-small-5">Keberadaan Aset Induk</span>
            <div class="col-12 mt-50">
                <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                    <b-form-radio v-model="formDatas.is_aset_induk" value="tidak" disabled>
                        Tidak Diketahui Aset Induknya
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.is_aset_induk" value="iya" disabled>
                        Diketahui Aset Induknya
                    </b-form-radio>
                </div>
            </div>
        </div>
        <div class="row mb-2" v-else-if="['beban'].includes(formDatas.biaya_beban)">
            <span class="col-12 font-weight-bold font-small-5">Jenis Beban</span>
            <div class="col-12 mt-50">
                <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                    <b-form-radio v-model="formDatas.jenis_beban" value="persediaan" disabled>
                        Beban Persediaan
                    </b-form-radio>
                    <b-form-radio v-model="formDatas.jenis_beban" value="beban-lainnya" disabled>
                        Beban Lainnya
                    </b-form-radio>
                </div>
            </div>
        </div>
        <div class="row mb-2" v-if="['beban'].includes(formDatas.biaya_beban) || formDatas.is_aset_induk != 'iya'">
            <span class="col-12 font-weight-bold font-small-5">Keterangan Biaya/Beban</span>
            <div class="col-12 mt-50">
                <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                    <div class="border border-1 rounded p-75 bg-light">
                        <span>{{ formDatas.kronologis_biaya_beban || '-' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <template
            v-if="['biaya-perolehan', 'biaya-setelah-perolehan'].includes(formDatas.biaya_beban) && formDatas.is_aset_induk == 'iya'">
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Nama PD/UKPD/UPB Aset Induk</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light">
                        <span>{{ formDatas.kolok_aset_induk || '-' }} :: {{ formDatas.nalok_aset_induk || '-' }}</span>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">KIB Aset Induk</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light">
                        <span>{{ formDatas.kib_aset_induk || '-' }} :: {{ formDatas.nama_kib_aset_induk || '-' }}</span>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Kode Barang Aset Induk</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light">
                        <span>{{ formDatas.kobar_aset_induk || '-' }} :: {{ formDatas.nabar_aset_induk || '-' }}</span>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5">Nomor Register Aset Induk</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light">
                        <span>{{
                            `${formDatas.noreg_aset_induk}::${formDatas.nabar_aset_induk}${`${(formDatas.alamat_noreg_aset_induk
                                ? `::${formDatas.alamat_noreg_aset_induk}` : '')}`}` }} </span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
  
<script>
import { ref, watch, watchEffect, onMounted } from '@vue/composition-api'
import vSelect from "vue-select";
import { id as localeId } from "vee-validate/dist/locale/id";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import masterBRef from "@/composables/master/masterBRef";
import { showNotifikasi } from '@/libs/helper';
import { VueGoodTable } from "vue-good-table";
import { parserValue } from '@/libs/helper'
import moment from 'moment';

export default {
    props: {
        fD: {
            type: Object,
            required: true,
        },
        disabled: { type: Boolean, default: false },
        updateItem: Function,
    },
    setup(props, context) {
        localize('id', localeId);
        const g = context.root;
        const formDatas = ref(props.fD);
        const year = moment().format('YYYY');

        /* Dataset */

        return {
            formDatas,
        }
    },
    computed: {
    },
    components: {
    },
    directives: {
        Ripple,
    },
    methods: {
    },

    data() {
        return {
            required,
        }
    },
}
</script>

<style lang="scss" scope>
.custom-control.custom-radio input:checked+.custom-control-label::before {
    /* Change this color to the desired color for the checked radio button */
    background-color: var(--primary) !important;
}

.custom-control.custom-radio input:checked+.custom-control-label {
    /* Change this color to the desired color for the label text when checked */
    color: var(--text-dark) !important;
}
</style>